import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { getVehicles } from "../lib/data";
import { Reveal } from "../components/Reveal";
import { usePageMeta } from "@/hooks/use-page-meta";
import { formatPrice, formatMonthlyKm } from "@/lib/price";

export default function Fleet() {
  usePageMeta({ title: "Filo", description: "2026 model sıfır kilometre premium sedan filomuz: Mercedes-Benz E180, A200 ve Skoda Superb. Kurumsal uzun dönem kiralama fiyatları." });
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getVehicles().then((v) => {
      setVehicles(v);
      setLoading(false);
    });
  }, []);

  return (
    <div className="py-20 px-6" data-testid="fleet-page">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <span className="text-xs font-mono-lbl uppercase tracking-widest text-[#8F7648]">
            Portföy
          </span>
          <h1 className="text-4xl md:text-6xl font-serif-display text-[#404040] mt-2">
            Seçkin Filomuz
          </h1>
          <p className="text-sm text-[#6B6B6B] mt-4 max-w-xl">
            Tamamı sıfır kilometre, 2026 model premium sedan araçlarımızla
            kurumsal prestijinizi yola taşıyın.
          </p>
        </Reveal>

        {loading ? (
          <div className="mt-16 text-[#6B6B6B] text-sm font-mono-lbl" data-testid="fleet-loading">
            Filo yükleniyor...
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
            {vehicles.map((v, i) => (
              <Reveal key={v.id} delay={i * 0.1}>
                <Link
                  to={`/filo/${v.slug}`}
                  data-testid={`fleet-card-${v.slug}`}
                  className="group block rounded-sm bg-white shadow-[0_4px_20px_rgba(176,144,96,0.05)] border border-[#B09060]/20 overflow-hidden hover:border-[#B09060]/50 transition-colors"
                >
                  <div className="h-56 overflow-hidden relative">
                    <img
                      src={v.image_url}
                      alt={v.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                      loading="lazy"
                    />
                    {v.badge && (
                      <span className="absolute top-3 left-3 px-3 py-1 rounded bg-white/90 backdrop-blur text-[#8F7648] text-[10px] font-mono-lbl uppercase tracking-widest border border-[#B09060]/40">
                        {v.badge}
                      </span>
                    )}
                  </div>
                  <div className="p-6">
                    <div className="text-[10px] font-mono-lbl uppercase tracking-widest text-[#6B6B6B]">
                      {v.segment} · {v.year}
                    </div>
                    <h3 className="text-lg font-bold text-[#404040] mt-1">{v.name}</h3>
                    <p className="text-xs text-[#6B6B6B] mt-2 leading-relaxed line-clamp-2">
                      {v.description}
                    </p>
                    <div className="flex items-end justify-between mt-5">
                      <div>
                        <span className="text-xl font-bold text-[#8F7648]">{formatPrice(v.price_label)}</span>
                        <span className="text-[10px] text-[#6B6B6B] ml-1">+ KDV / Ay</span>
                        {formatMonthlyKm(v.monthly_km) && (
                          <div className="text-[11px] text-[#6B6B6B] mt-1">{formatMonthlyKm(v.monthly_km)}</div>
                        )}
                      </div>
                      <ArrowRight className="w-4 h-4 text-[#9B9B8F] group-hover:text-[#8F7648] group-hover:translate-x-1 transition-all" />
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
